module.exports = __webpack_public_path__ + "static/media/cintilloLogo.98ddacac.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cintilloLogo.png
// module id = 1013
// module chunks = 0